import { Button, Listbox, ListboxOption, ListboxValue } from '@teliaee/design-system';
import { observer } from 'mobx-react';
import * as React from 'react';
import { MandateCustomer, Segment } from '../CommonInterfaces';
import GaDataStore from '../stores/GaDataStore';
import useStores from '../stores/UseStores';
import { runInTeliaRumService } from '../util/TeliaOtelUtil';

interface MandateListItemsProps {
  b2cMandates: MandateCustomer[];
  b2bMandates: MandateCustomer[];
}

const MandateListItems = observer((props: MandateListItemsProps): React.JSX.Element => {
  const { b2cMandates, b2bMandates } = props;
  const {
    mandateStore,
    translateStore: { translate },
  } = useStores();

  const registerB2b = () => {
    runInTeliaRumService('Uue ärikliendi registreerimine', () => {
      GaDataStore.registerB2B();
      mandateStore.registerCompany();
    });
  };

  const handleSelectMandate = (listboxValue: ListboxValue) => {
    const segment: Segment = listboxValue?.split('-').shift()?.toUpperCase() as Segment;

    runInTeliaRumService(`Esindatava vahetamine (${segment === 'B2B' ? 'Äriklient' : 'Eraklient'})`, () => {
      const index: number = +(listboxValue?.split('-').pop() || 0);
      const mandate: MandateCustomer = (segment === 'B2B' ? b2bMandates : b2cMandates)[index];
      GaDataStore.selectMandate(segment);
      mandateStore.selectMandate(mandate.orderingIndex);
    });
  };

  return (
    <>
      <Listbox aria-labelledby="mandates-title" value={mandateStore.selectedMandateValue} onChange={handleSelectMandate}>
        {b2cMandates.map(
          (item: MandateCustomer, index: number): React.JSX.Element => (
            <ListboxOption
              key={`b2c-mandate-list-item-${index}`}
              value={`b2c-mandate-list-item-${index}`}
              label={item.displayName}
              description={`${translate('mandates.b2c')}, ${item.registrationNumber}`}
              icon="#contact"
            />
          ),
        )}
        {!mandateStore.hideB2B &&
          b2bMandates.map(
            (item: MandateCustomer, index: number): React.JSX.Element => (
              <ListboxOption
                key={`b2b-mandate-list-item-${index}`}
                value={`b2b-mandate-list-item-${index}`}
                label={item.displayName}
                description={translate('mandates.b2b')}
                icon="#business-services"
              />
            ),
          )}
      </Listbox>
      {mandateStore.registrableCompanies && (
        <Button text={translate('mandates.registerB2b')} iconLeft="#plus-round" link={true} type="text-color" onClick={registerB2b} />
      )}
    </>
  );
});

export default MandateListItems;
